import { useEffect, useState } from "react";
import { Page, Composer, MessageList, Skeleton } from "../components/ui.jsx";
import { readList, appendItem } from "../lib/storage.js";

// Per-class discussion thread. Keyed by the course id so each class keeps its own.
export default function Thread({ back, node, userName }) {
  const key = "chat:" + node.id;
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    readList(key).then((list) => {
      setItems(list);
      setLoading(false);
    });
  }, [key]);

  return (
    <Page
      back={back}
      eyebrow="Class Chatter"
      title={node.name + "."}
      intro="Public discourse for this class — questions, takeaways, and what hit different. Everything here is visible to everyone in the hub."
    >
      <Composer
        placeholder="Drop your takeaway, question, or word…"
        onPost={async (text) =>
          setItems(await appendItem(key, { name: userName, text, ts: Date.now() }))
        }
      />
      {loading ? (
        <Skeleton />
      ) : (
        <MessageList
          items={items}
          empty="Nobody's posted yet. Be the first voice in the room."
        />
      )}
    </Page>
  );
}
